import React from "react";
import "../../assets/css/seller-account.css";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Seller_sidebar from "./Seller-sidebar/Seller_sidebar";
import Seller_tabs_list from "./Seller-sidebar/Seller_tabs_list";
import { ad1 } from "../../constants";
import SellerHeader from "../../components/SellerHeader/SellerHeader";
import SellerFooter from "../../components/SellerFooter/SellerFooter";

const Seller_account = () => {
	return (
		<>
			{/* Header starts here */}
			<SellerHeader />
			{/* Header ends here */}
			<section className="dashboard sob">
				<div className="container">
					<div className="row">
						<div className="col-lg-4">
							<Seller_sidebar />
							{/* <div className="sidebar-subcription-wrapper">
								<div className="sub-heading-wrapper">
									<h5>Subscription Package</h5>
									<a href="/Subscription_Type">Change</a>
								</div>
								<div className="monthly-wrapper">
									<div className="monthly-head-wrapper">
										<h4>Monthly</h4>
										<p>
											Lorem ipsum dolor sit amet, consectetuer adipiscing elit.
											Aliquam tincidun
										</p>
									</div>
									<div className="monthly-per-video-wrapper">
										<h6>Monthly</h6>
										<div className="permonth-wrapper">
											<h5>Per Month</h5>
											<h6>$75.00</h6>
										</div>
									</div>
								</div>
							</div> */}
						</div>
						<div className="col-lg-8">
							<Seller_tabs_list />
							{/* View banner ads starts here */}
							<div className="bussiness_information">
								<div className="headings_warpper">
									<h4>Personal Information</h4>
									<a href="/seller-info" className="edit-btn">
										Add Info
									</a>
								</div>
								<div className="row">
									<div className="col-md-6">
										<div className="bussiness_info_box">
											<div className="detail bname">
												<p className="property">First Name:</p>
												<span className="value">John</span>
											</div>
											<div className="detail TLnum">
												<p className="property">Last Name:</p>
												<span className="value">Doe</span>
											</div>
											<div className="detail Bcnum">
												<p className="property">Age:</p>
												<span className="value">33</span>
											</div>
											<div className="detail bemail">
												<p className="property">City</p>
												<span className="value">Houston</span>
											</div>
											<div className="detail owner_name">
												<p className="property">Business Type</p>
												<span className="value">Products Selling</span>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="bussiness_info_box">
											<div className="detail Bnum">
												<p className="property">Country</p>
												<span className="value">USA</span>
											</div>
											<div className="detail btype">
												<p className="property">Phone</p>
												<span className="value">12-345-67890</span>
											</div>
											<div className="detail Baddress">
												<p className="property">Email</p>
												<span className="value">john@examplecom</span>
											</div>
											<div className="detail pcategroy">
												<p className="property">Company / Business name</p>
												<span className="value">Apricot</span>
											</div>
											<div className="detail pcategroy">
												<p className="property">Designation</p>
												<span className="value">Sales manager</span>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="bussiness_information">
								<div className="headings_warpper">
									<h4>Business information</h4>
									<a href="/seller-edit-info" className="edit-btn">
										Add Info
									</a>
								</div>
								<div className="row">
									<div className="col-md-6">
										<div className="bussiness_info_box">
											<div className="detail bname">
												<p className="property">Business name</p>
												<span className="value">Koizuma Massage</span>
											</div>
											<div className="detail TLnum">
												<p className="property">Trade LIcence Number</p>
												<span className="value">J1S234-987</span>
											</div>
											<div className="detail Bcnum">
												<p className="property">Business Contact Number</p>
												<span className="value">+971-324-4856879</span>
											</div>
											<div className="detail bemail">
												<p className="property">Email</p>
												<span className="value">info@johnyphones.com</span>
											</div>
											<div className="detail owner_name">
												<p className="property">Owner Name</p>
												<span className="value">John Anderson</span>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="bussiness_info_box">
											<div className="detail Bnum">
												<p className="property">Business Contact Number</p>
												<span className="value">+971-124-21345678</span>
											</div>
											<div className="detail btype">
												<p className="property">Business Type</p>
												<span className="value">Retailer</span>
											</div>
											<div className="detail Baddress">
												<p className="property">Head Office Address</p>
												<span className="value">
													Suit# 200A lorem Tower
													<br />
													ipsum road. DX12345
												</span>
											</div>
											<div className="detail pcategroy">
												<p className="property">Main Products Catagories</p>
												<span className="value">Koizuma Massage Gun </span>
											</div>
										</div>
									</div>
								</div>
							</div>
							{/* View banner ads ends here */}
						</div>
					</div>
				</div>
			</section>
			{/* Footer starts here */}
			<SellerFooter />
			{/* Footer ends here */}
		</>
	);
};

export default Seller_account;
